// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pZ6Z","icon":"styles_icon__1wX7F"};